import styled from "styled-components"


const Title = styled.div`
  font-size: 2rem;
  font-weight: 600;
  /* //rgb(194, 23, 29); */
  color: ${props => props.theme.default.primary}; 
  text-align: center;
  padding-top: 3.5rem;
  /* padding-bottom: 15px; */
`
const MainContainer = styled.div`
  max-width: 100rem;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 3.5rem;
`
const ContentContainer = styled.div`
  width: 100%;
  text-align: justify;
  font-size: 1.4rem;
  padding: ${props => props.padding ? props.padding : "1.2rem 2rem 0rem 2rem"};
`
const SubTitle = styled.div`
  font-size: 1.6rem;
  font-weight: 500;
  text-align: left;
  /* color: rgb(194, 23, 29); */
  color: ${props => props.theme.default.primary}; 
`
const Bold = styled.span`
  font-size: 1.4rem;
  font-weight: bold;
`
const Contact = styled.p`
  font-size: 1.4rem;
  text-align: center;
  width: 100%;
`
const LinkStyle = styled.a`
  font-size: 1.4rem;
  text-decoration: none;
  font-weight: bold;
  color: rgb(194, 23, 29);
`

export {
  Title,
  MainContainer,
  ContentContainer,
  SubTitle,
  Bold,
  Contact,
  LinkStyle,
}
